<template>
  <div id="modal" class="modal-backdrop" @click.self="$emit('close')">
    <div class="modal">
      <img
        width="16"
        src="@/assets/icons/close.svg"
        class="btn-close whiteIMG"
        @click="close"
        alt=""
      />
      <div class="modal-header">ایجاد تیکت جدید</div>
      <div class="modal-body">
        <form @submit.prevent="submit">
          <div>
            <custom-input
              class="input"
              type="text"
              name="birthday"
              :theme="state.theme"
              :value="data.subject"
              @input="(e) => (data.subject = e.value)"
              require
              label="عنوان"
            />
            <custom-input
              :marketList="types"
              label="بخش"
              option="label"
              :value="data.type"
              @input="(e) => (data.type = e.value)"
              :theme="state.theme"
              :box-border="state.theme === 'light'"
              color="var(--light-grey)"
              fontcolor="var(--fontcolor)"
            />
          </div>

          <textarea v-model="data.text" name="text" placeholder="متن پیام" />
          <button
            hidden
            type="submit"
            :disabled="!data.subject || !data.type || !data.text"
          />
        </form>
      </div>
      <div class="modal-btn">
        <button
          type="submit"
          class="submit"
          @click="submit"
          :disabled="!data.subject || !data.type || !data.text"
        >
          ارسال
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import CustomInput from "./customInput";

export default {
  name: "SupportModal",
  components: { CustomInput },
  data() {
    return {
      amount: "",
      data: {
        type: "",
        subject: "",
        text: "",
      },
      types: [
        {
          label: "قنی",
          value: "TECHNICAL",
        },
        {
          label: "عمومی",
          value: "GENERAL",
        },
      ],
    };
  },
  computed: {
    typeValue() {
      return this.types.filter((e) => e.label === this.data.type)[0].value;
    },
  },
  mounted() {
    document.body.style.overflow = "hidden";
  },
  beforeDestroy() {
    document.body.style.overflow = "auto";
  },
  methods: {
    close() {
      this.$emit("close");
    },
    async submit() {
      let formData = new FormData();
      for (let a in this.data) {
        if (a === "type") {
          formData.append(a, this.typeValue);
        } else {
          formData.append(a, this.data[a]);
        }
      }
      if (this.data.subject && this.data.type && this.data.text) {
        this.state.loading = true;
        const res = await this.$axios.post("/tickets", formData);
        this.$push({
          name: "SupportMassage",
          params: {
            id: res.baseDTO.id,
          },
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: var(--modal-back);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  color: var(--fontcolor);
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
}

.modal {
  position: relative;
  background: var(--box);
  border-radius: 5px;
  overflow-x: auto;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 570px;
}

.modal-header {
  font-size: 20px;
  display: flex;
  justify-content: center;
  border-bottom: 1px solid var(--border);
  padding: 10px 0;
}

.btn-close {
  position: absolute;
  right: 15px;
  top: 15px;
  transition: 0.3s;
  cursor: pointer;
  z-index: 5;
}

.btn-close:hover {
  transform: scale(1.3);
}

.modal-body {
  margin-top: 20px;
  position: relative;
  background-color: transparent;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
  padding: 0 30px 20px;
}

form {
  > div {
    display: flex;
    gap: 20px;
    label {
      width: 100%;
    }
  }
  textarea {
    width: 100%;
    margin-top: 16px;
    border-radius: 5px;
    background-color: var(--light-grey);
    color: var(--fontcolor);
    padding: 10px;
    resize: none;
  }
}

.modal-btn {
  height: 60px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  background-color: transparent;
  width: 100%;
  padding: 30px;
  padding-top: 0;

  .submit {
    width: 100px;
    height: 40px;
  }
}

.normal-btn {
  font-size: 16px;
  color: white;
  max-width: 200px;
  margin: 0;
  border-radius: 5px;
  height: 40px;
  padding: 0;
  border: 2px solid var(--yellow);
  background-color: var(--yellow);
  transition: 0.3s;
  cursor: pointer;
  width: 100%;

  &:hover {
    color: var(--fontcolor);
    background-color: transparent;
  }
}

.link {
  cursor: pointer;
  align-self: flex-end;
}

.link:hover {
  text-decoration: underline;
  color: var(--yellow);
}

.select {
  overflow: hidden;
  position: relative;
}

.select a {
  position: absolute;
  top: 50%;
  left: 15px;
  width: 11px;
  height: 11px;
  border-left: black solid 4px;
  border-radius: 1px;
  border-bottom: black solid 4px;
  transform: translate(0, -65%) rotate(-45deg);
  transition: 0.25s;
}

.form-textarea {
  width: 100%;
  display: flex;
  margin: 5px 0;
  padding: 0 5px;

  textarea {
    width: 100%;
    height: 90px;
    border-radius: 5px;
    resize: none;
    border: 1px solid var(--border);
    color: var(--fontcolor);
    padding: 7px;
    margin: auto;
  }
}
</style>
